// Гид (К-09, К-10): «Футбол для родителей за 10 минут» и «Как поддерживать ребёнка».
import { Link, useNavigate, useParams } from "react-router";
import { TopBar } from "../components/Shell.tsx";
import { guideArticles } from "../lib/content/catalog.ts";
import { useApp } from "../state/app.ts";
import { t } from "../i18n/ru.ts";

export function Guide() {
  const content = useApp((s) => s.content);
  const articles = content ? guideArticles(content) : [];
  const sections = [
    { key: "basics", title: t.guide.basics },
    { key: "support", title: t.guide.support },
    { key: "problems", title: t.guide.problems },
  ];
  return (
    <div className="page">
      <TopBar title={t.guide.title} />
      {sections.map((sec) => {
        const list = articles.filter((a) => a.section === sec.key);
        if (!list.length) return null;
        return (
          <section key={sec.key}>
            <h2 className="section-title">{sec.title}</h2>
            <ul className="link-list">
              {list.map((a) => (
                <li key={a.id}>
                  <Link to={`/guide/${encodeURIComponent(a.id)}`} className="card link-card">
                    <strong>{a.title}</strong>
                    <span className="muted">{a.summary}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}

/** Абзацы статьи: строки «- …» — пункты списка. */
function Paragraphs({ items }: { items: string[] }) {
  const out: React.ReactNode[] = [];
  let list: string[] = [];
  const flush = () => {
    if (list.length) out.push(<ul key={out.length}>{list.map((x) => <li key={x}>{x}</li>)}</ul>);
    list = [];
  };
  for (const p of items) {
    if (p.startsWith("- ")) list.push(p.slice(2));
    else {
      flush();
      out.push(<p key={out.length}>{p}</p>);
    }
  }
  flush();
  return <>{out}</>;
}

export function Article() {
  const { id = "" } = useParams();
  const nav = useNavigate();
  const content = useApp((s) => s.content);
  const a = content ? guideArticles(content).find((x) => x.id === id) : undefined;
  if (!a) return <p className="page">{t.player.notFound}</p>;
  return (
    <div className="page article">
      <TopBar title={a.title} back={() => nav(-1)} />
      {a.body.map((b, i) => (
        <section key={i}>
          {b.heading ? <h2>{b.heading}</h2> : null}
          <Paragraphs items={b.paragraphs} />
        </section>
      ))}
      {a.related.length ? (
        <>
          <h3>{t.guide.related}</h3>
          <ul className="link-list">
            {a.related.map((r) => (
              <li key={r}>
                <Link to={r.startsWith("course/") ? `/course/${encodeURIComponent(r)}` : `/scenario/${encodeURIComponent(r)}`}>{r.startsWith("course/") ? content?.courses.find((c) => c.course.id === r)?.course.title ?? r : content?.courses.flatMap((c) => c.scenarios).find((s) => s.scenario.id === r)?.scenario.title ?? r}</Link>
              </li>
            ))}
          </ul>
        </>
      ) : null}
      <p className="muted small">
        {t.guide.sources}: {a.sources.map((s) => s.section).join("; ")}
      </p>
    </div>
  );
}
